import * as v from "valibot";
import { rpcContract } from "../rpc";

export const deleteChatMessageRpcContract = rpcContract({
  name: "delete-chat-message",
  paramsSchema: v.object({
    scope: v.picklist(["live", "community"]),
    messageId: v.pipe(v.string(), v.uuid()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    errorMessage: v.optional(v.string()),
  }),
});

export type DeleteChatMessageParams = v.InferOutput<typeof deleteChatMessageRpcContract.paramsSchema>;
export type DeleteChatMessageResult = v.InferOutput<typeof deleteChatMessageRpcContract.resultSchema>;
